<script setup lang="ts">
import type { HTMLAttributes } from "vue";
import { tw } from "../../../utils/tailwind";

interface Props {
    class?: HTMLAttributes["class"];
    asChild?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
    asChild: true,
});
</script>

<template>
  <button
      :as-child="asChild"
      :class="tw(
          'flex h-10 w-10 items-center justify-center rounded-full border border-primary text-primary hover:bg-primary hover:text-white transition',
           'bg-white text-primary-600',
           props.class,
      )"
  >
    <slot/>
  </button>
</template>
